/**
 * Download a blob in the browser. Keeps the object URL for a tick so Safari
 * can start the download before the link is removed.
 * @param {Blob | ArrayBuffer | Uint8Array} data
 * @param {string} filename
 * @param {string} [mimeType]
 */
export function downloadFile(data, filename, mimeType) {
  const blob =
    data instanceof Blob
      ? data
      : new Blob([data], mimeType ? { type: mimeType } : undefined)

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()

  setTimeout(() => {
    window.URL.revokeObjectURL(url)
    document.body.removeChild(link)
  }, 100)
}
